/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { HomePageData } from './HomePageData'
import {
  HomePageDataFromJSON,
  HomePageDataFromJSONTyped,
  HomePageDataToJSON,
} from './HomePageData'

/**
 *
 * @export
 * @interface GetHome200Response
 */
export interface GetHome200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetHome200Response
   */
  status: boolean
  /**
   *
   * @type {HomePageData}
   * @memberof GetHome200Response
   */
  data: HomePageData
}

/**
 * Check if a given object implements the GetHome200Response interface.
 */
export function instanceOfGetHome200Response(
  value: object
): value is GetHome200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetHome200ResponseFromJSON(json: any): GetHome200Response {
  return GetHome200ResponseFromJSONTyped(json, false)
}

export function GetHome200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetHome200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: HomePageDataFromJSON(json['data']),
  }
}

export function GetHome200ResponseToJSON(
  value?: GetHome200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: HomePageDataToJSON(value['data']),
  }
}
